// domainConfig.js
export const domainConfigs = {
  system: {
    terms: {
      title: 'System Administrators',
      welcome: 'Welcome to ThermalSafe Configuration',
      logout: 'Sign Out',
      tenant: 'Company',
      tenants: 'Companies',
      site: 'Site',
      sites: 'Sites',
      gateway: 'Gateway',
      gateways: 'Gateways',
      camera: 'Camera',
      cameras: 'Cameras',
      target: 'Target',
      targets: 'Targets',
      alert: 'Alert',
      alerts: 'Alerts',
      itemType: 'Item Type',
      itemId: 'Item ID',
      description: 'Description'
    },
    images: {
      logo: '/images/system/logo.png'
    },
    theme: 'system'
  },
  switchgear: {
    terms: {
      title: 'SwitchGear Monitoring',
      welcome: 'Welcome to TS SwitchGear Monitoring',
      logout: 'Sign Out',
      tenant: 'Company',
      tenants: 'Companies',
      site: 'Site',
      sites: 'Sites',
      gateway: 'Gateway',
      gateways: 'Gateways',
      camera: 'Camera',
      cameras: 'Cameras',
      target: 'Target',
      targets: 'Targets',
      alert: 'Alert',
      alerts: 'Alerts',
      itemType: 'Item Type',
      itemId: 'Item ID',
      description: 'Description'
    },
    images: {
      logo: '/images/switchgear/logo.png'
    },
    theme: 'switchgear'
  },
  rail: {
    terms: {
      title: 'Rail Monitoring',
      welcome: 'Welcome to TS Rail Monitoring',
      logout: 'Sign Out',
      tenant: 'Rail Operator',
      tenants: 'Rail Operators',
      site: 'Railcar',
      sites: 'Railcars',
      gateway: 'Wheel',
      gateways: 'Wheels',
      camera: 'Thermal Camera',
      cameras: 'Thermal Cameras',
      target: 'Target',
      targets: 'Targets',
      alert: 'Alert',
      alerts: 'Alerts',
      itemType: 'Item Type',
      itemId: 'Item ID',
      description: 'Description'
    },
    images: {
      logo: '/images/rail/logo.png'
    },
    theme: 'rail'
  },
  all: {
    terms: {
      title: 'System Administrators',
      welcome: 'Welcome to ThermalSafe',
      logout: 'Sign Out',
      tenant: 'Company',
      tenants: 'Companies',
      site: 'Site',
      sites: 'Sites',
      gateway: 'Gateway',
      gateways: 'Gateways',
      camera: 'Camera',
      cameras: 'Cameras',
      target: 'Target',
      targets: 'Targets',
      alert: 'Alert',
      alerts: 'Alerts',
      itemType: 'Item Type',
      itemId: 'Item ID',
      description: 'Description'
    },
    images: {
      logo: '/images/default/logo.png'
    },
    theme: 'default'
  }
}
